<template>
  <div class="d-flex flex-wrap">
    <div v-for="(element, i) in elements" :key="i" :class="element.class">
      <div class="form-group" v-if="element.element == 'select'">
        <label for="">{{ element.label }}</label>
        <select
          class="form-control"
          :required="element.required || false"
          :name="element.name"
          @change="element.onChange"
        >
          <option
            v-for="(option, i) in element.options" :key="i"
            :value="option.value"
            :selected="option.selected || false"
          >{{ option.label }}</option>
        </select>
      </div>
      <CInput
        v-else
        :type="element.type || 'text'"
        :placeholder="element.placeholder"
        :label="element.label"
        :name="element.name"
        :value="element.value"
        :required="element.required || false"
      >
      </CInput>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormBuilder",
  props: {
    elements: Array,
  },
};
</script>